import React, { Component } from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';

import NavButton from '../component/navigation/NavButton';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { FontAwesome } from 'react-js-vector-icons';
import Cookies from "universal-cookie";

import Header from '../component/Header';

export default class Home extends Component {
  constructor( props ) {
    super( props );

    let cookies = new Cookies();
    let session = cookies.get( 'session' );

    if( !session ) {
      window.location.href = '/auth';
    }
  }
  search = ( value ) => {
    alert( value );
  }

  render() {
    return (
      <Fabric className="ms-Fabric" style={{ paddingBottom: 20 }}>
        <Header back={false} />
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12" style={{ position: 'relative', margin: 0, marginBottom: 20, padding: 0, backgroundImage: "url('/assets/images/people.jpg')", backgroundSize: 'cover', backgroundRepeat: 'none', height: 300 }}>
              <h1 style={{ position: 'absolute', bottom: 5, left: 10, color: '#fcfcfc' }}>Bienvenido</h1>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm10 ms-lg1"></div>
            <div className="ms-Grid-col ms-sm10 ms-textAlignRight" style={{ paddingRight: 30 }} >
              <a href="/settings" style={{ textDecoration: 'none' }}><FontAwesome name="cog" size={14} color="##0056b3" /> Configuración...</a>  
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginBottom: 10 }}>
            <div className="ms-Grid-col ms-sm12 ms-lg1"></div>
            <div className="ms-Grid-col ms-sm12 ms-lg10" style={{ paddingTop: 20, borderBottom: '1px solid #ccc'}} >
              { false && 
              <SearchBox
                placeholder="Buscar entre los clientes, pólizas y siniestros..."
                onSearch={ this.search }
                underlined={ true }  />
              }
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <div className="ms-Grid-row" style={{ marginTop: 30 }}>
                <div className="ms-Grid-col ms-sm1 ms-lg1"></div>
                <div className="ms-Grid-col ms-sm11 ms-lg10"><h1>Módulos</h1></div>
              </div>
              <div className="ms-Grid-row" style={{ marginBottom: 10 }}>
                <div className="ms-Grid-col ms-sm1 ms-lg2"></div>
                <div className="ms-Grid-col ms-sm11 ms-lg10">
                  <NavButton target="/clients" iconName="group" iconSize={30} title="Clientes" />
                  <NavButton target="/policies" iconName="handshake-o" iconSize={30} title="Pólizas" />
                  <NavButton target="/sinesters" iconName="wrench" iconSize={30} title="Siniestros" />
                </div>
              </div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <div className="ms-Grid-row" style={{ marginTop: 30 }}>
                <div className="ms-Grid-col ms-sm1 ms-lg1"></div>
                <div className="ms-Grid-col ms-sm11 ms-lg10"><h1>Procesos</h1></div>
              </div>
              <div className="ms-Grid-row" style={{ marginBottom: 10 }}>
                <div className="ms-Grid-col ms-sm1 ms-lg2"></div>
                <div className="ms-Grid-col ms-sm11 ms-lg10">
                  <NavButton target="/policy-renew" iconName="refresh" iconSize={30} title="Renovar póliza" />
                  <NavButton target="/sinester-new" iconName="ambulance" iconSize={30} title="Denunciar siniestro" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/Home.jsx